import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/ceo-practitioner-network")({
  beforeLoad: () => {
    throw redirect({ href: "https://ceopractitionernetwork.com", replace: true });
  },
  head: () => ({
    meta: [
      { title: "CEO Practitioner Network" },
      { name: "robots", content: "noindex, follow" },
    ],
    links: [{ rel: "canonical", href: "https://ceopractitionernetwork.com" }],
  }),
  component: () => null,
});
